/**
 * @file The context for the currently selected projector.
 * This does NOT indiciate if an active filter is set on a library/schedule page
 */

import type { Device } from "luxedo-data"
import { writable } from "svelte/store"

export const SelectedDeviceStore = writable<Device>(null)
